const API = `${process.env.REACT_APP_BACKEND_URL}/api/readiness-chat`;

const parseError = async (response) => {
  try {
    const payload = await response.json();
    return payload.detail || "The TENET guide is unavailable right now.";
  } catch {
    return "The TENET guide is unavailable right now.";
  }
};

export const createReadinessSessionId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID().replaceAll("-", "_");
  return `tenet_${Date.now()}_${Math.random().toString(36).slice(2, 18)}`;
};

export const getReadinessHistory = async (sessionId, signal) => {
  const response = await fetch(`${API}/${sessionId}`, { signal });
  if (!response.ok) throw new Error(await parseError(response));
  return response.json();
};

export const deleteReadinessConversation = async (sessionId) => {
  const response = await fetch(`${API}/${sessionId}`, { method: "DELETE" });
  if (!response.ok) throw new Error(await parseError(response));
  return response.json();
};

export const streamReadinessMessage = async ({ sessionId, message, mode, signal, onDelta }) => {
  const response = await fetch(`${API}/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, message, mode }),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response));
  if (!response.body) throw new Error("Streaming is not supported in this browser.");

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const blocks = buffer.split("\n\n");
    buffer = blocks.pop() || "";

    for (const block of blocks) {
      const data = block.split("\n").find((line) => line.startsWith("data: "));
      if (!data) continue;
      const event = JSON.parse(data.slice(6));
      if (event.type === "delta") onDelta(event.content);
      if (event.type === "error") throw new Error(event.message);
    }
  }
};